// THIS MUST BE THE FIRST LINE
import 'react-app-polyfill/stable';

import { theme } from '@met/react-components';
import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';

import App from './App';
import './config/fontAwesome';
import history from './history';
import IntlProvider from './locales/IntlProvider';
import { unregister } from './registerServiceWorker';
import configureStore from './store/configureStore';
import { NAVIGATION } from './store/types';

// configure react toastify
toast.configure({
  autoClose: 8000,
  draggable: false,
  position: toast.POSITION.BOTTOM_RIGHT,
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
let lastLocation = history.location;

// Whenever our route changes, dispatch a navigation event and reset our scroll position
history.listen((location, action) => {
  if (
    location.pathname + location.search !==
    lastLocation.pathname + lastLocation.search
  )
    store.dispatch({ type: NAVIGATION });

  lastLocation = location;
  window.scrollTo(0, 0);
});

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ConnectedRouter>
    </IntlProvider>
  </Provider>,
  rootElement
);

unregister();
